import type { SVGProps } from 'react';

export const ArrowUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M13.0026 6.08258L13.0026 20.3332C13.0026 20.8852 12.5546 21.3332 12.0026 21.3332C11.4506 21.3332 11.0026 20.8852 11.0026 20.3332L11.0026 6.07991L7.04126 10.0412C6.6506 10.4319 6.01727 10.4319 5.6266 10.0412C5.23593 9.65057 5.23593 9.01724 5.6266 8.62657L11.2933 2.95992C11.4879 2.76525 11.7439 2.66659 11.9999 2.66659L12.0026 2.66659C12.2586 2.66659 12.5146 2.76392 12.7092 2.95992L18.3759 8.62657C18.7666 9.01724 18.7666 9.65057 18.3759 10.0412C17.9852 10.4319 17.3519 10.4319 16.9612 10.0412L13.0026 6.08258Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
